import {Button, CopyButton, Dialog} from '@wandb/components';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import React from 'react';

type RawCodeModalProps = {
  header: string | null;
  isOpen: boolean;
  json: string | null;
  onClose(): void;
};

export function RawCodeModal({
  header,
  isOpen,
  json,
  onClose,
}: RawCodeModalProps) {
  return (
    <Dialog.Modal
      UNSAFE_fullscreen
      isOpen={isOpen}
      onOpenChange={open => {
        if (!open) {
          onClose();
        }
      }}
      aria-label={header ?? 'Raw code'}>
      {header != null ? <Dialog.Heading>{header}</Dialog.Heading> : null}
      <Dialog.Content>
        <Tailwind>
          <div className="max-h-[70vh] overflow-auto rounded-lg border border-wb-border bg-wb-surface-sunken p-12 dark:border-moon-700 dark:bg-moon-800">
            <pre className="text-wb-text-primary dark:text-moon-200">
              {json}
            </pre>
          </div>
        </Tailwind>
      </Dialog.Content>
      <Dialog.Footer>
        <Button onPress={onClose}>Close</Button>
        <CopyButton aria-label="Copy raw code" content={json ?? ''} size="sm" />
      </Dialog.Footer>
    </Dialog.Modal>
  );
}
